import React from "react";
import * as Icons from "lucide-react";

const gradients = [
  "from-orange-500 to-red-600", "from-cyan-400 to-teal-600", "from-amber-400 to-orange-600",
  "from-emerald-400 to-teal-700", "from-fuchsia-500 to-purple-700", "from-rose-500 to-pink-700",
  "from-sky-400 to-blue-700", "from-lime-400 to-emerald-700", "from-violet-500 to-indigo-700",
  "from-teal-400 to-cyan-700",
];

export default function CategoryCard({ category, active, onClick, index = 0 }) {
  const Icon = Icons[category.icon] || Icons.Smartphone;
  const gradient = gradients[index % gradients.length];
  return (
    <button
      onClick={onClick}
      className={`shrink-0 flex flex-col items-start gap-3 rounded-2xl p-4 w-36 border transition ${
        active ? "border-white/40 bg-white/10" : "border-white/10 bg-white/5 hover:border-white/25"
      }`}
    >
      <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${gradient} flex items-center justify-center`}>
        <Icon size={16} className="text-white" />
      </div>
      <span className="text-xs font-medium text-left leading-tight">{category.name}</span>
    </button>
  );
}
